import { createFileRoute, redirect } from '@tanstack/react-router';
import { ensureAuthData } from '@/api/auth/auth-query';
import { queryClient } from '@/api/common/client';
import { REFERRER_DASHBOARD } from '@/lib/constants/routes';
import { InfrastructureCostsPage } from '@/pages/admin/infrastructure-costs';
import { infrastructureCostsSearchSchema } from '@/routes/-shared/infrastructureCostsSearchSchema';

export const Route = createFileRoute('/referrer/_layout/infrastructure-costs')({
  beforeLoad: async () => {
    const data = await ensureAuthData(queryClient);
    if (!data.user?.canViewInfrastructureCosts) {
      throw redirect({ to: REFERRER_DASHBOARD });
    }
  },
  validateSearch: infrastructureCostsSearchSchema,
  component: () => <InfrastructureCostsPage readOnly />,
});
